import Header from "@/sections/Header";
import FooterSection from "@/sections/Footer";
import GetInvolved from "@/sections/GetInvolved";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "/dcyb-logo.png";

export default function GetInvolvedPage() {
  useEffect(() => {
    document.title = "Get Involved · DCYB";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="get-involved-page" className="relative">
      <Header />

      {/* Intro band */}
      <section
        data-testid="get-involved-intro"
        className="pt-[60px] md:pt-[88px] pb-12 md:pb-16 border-b hairline relative overflow-hidden bg-white"
      >
        {/* Subtle chrome reflection grid */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none opacity-[0.5]"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(15,17,23,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(15,17,23,0.05) 1px, transparent 1px)",
            backgroundSize: "80px 80px",
            maskImage:
              "radial-gradient(800px 500px at 50% 50%, #000 30%, transparent 75%)",
            WebkitMaskImage:
              "radial-gradient(800px 500px at 50% 50%, #000 30%, transparent 75%)",
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(700px 500px at 85% 100%, rgba(15,17,23,0.08), transparent 60%)",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="back-to-home-link"
            className="inline-flex items-center gap-2 font-mono-label text-[11px] text-[#5F6168] hover:text-[#0F1117] transition-colors mb-10"
          >
            <ArrowLeft size={14} />
            Back to DCYB
          </Link>

          <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
            <img
              src={LOGO_URL}
              alt=""
              aria-hidden
              className="w-16 h-16 md:w-20 md:h-20 object-contain mb-8"
              draggable="false"
            />

            <div data-testid="get-involved-page-section-label" className="font-mono-label text-[11px] text-[#0F1117] mb-6">
              / Get involved
            </div>

            <h1
              data-testid="get-involved-page-title"
              className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight font-extrabold text-[#0F1117] text-balance mb-8"
            >
              Tell us <span className="text-chrome">where you fit.</span>
            </h1>

            <p className="text-[15px] md:text-base text-[#52555B] leading-relaxed max-w-2xl text-balance">
              {"One form, unlimited ways in. Partnership, collaboration, sponsorship, hiring, training, community, funding. Pick what fits and we will meet you there."}
            </p>
          </div>
        </div>
      </section>

      {/* Form — reuses the same component, header hidden */}
      <GetInvolved compact />

      <FooterSection />
    </main>
  );
}
